import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { Utilities } from '../../helpers/Utilities';
import { CreateScheduleDTO } from '../../models/Scheduler/CreateScheduleDTO';
import { SchedulerService } from '../../services/SchedulerService';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import SelectComponent from '../SelectComponent';

type CreateSchedulerThirdTabProps = {
    scheduleDTO: CreateScheduleDTO;
    setScheduleDTO: React.Dispatch<React.SetStateAction<CreateScheduleDTO>>;

    onFetchData: () => void;
};

function CreateSchedulerThirdTab(props: CreateSchedulerThirdTabProps) {

    const [isCreatingSchedulingLoading, setIsCreatingSchedulingLoading] = useState<boolean>(false);
    const schedulerService = new SchedulerService();
    const intl = useIntl();


    const [executionStartDate, setExecutionStartDate] = useState<string>(
        props.scheduleDTO.executionStartDate ? Utilities.formatDateYYYYMMDD(new Date(props.scheduleDTO.executionStartDate)) : Utilities.formatDateYYYYMMDD(new Date())
    );
    const [executionStartTime, setExecutionStartTime] = useState<string>(
        props.scheduleDTO.executionStartDate ? Utilities.GetTimeFromDateTime(new Date(props.scheduleDTO.executionStartDate)) : Utilities.GetTimeFromDateTime(new Date())
    );
    const [executionEndDate, setExecutionEndDate] = useState<string>(
        props.scheduleDTO.executionEndDate ? Utilities.formatDateYYYYMMDD(new Date(props.scheduleDTO.executionEndDate)) : Utilities.formatDateYYYYMMDD(new Date())
    );
    const [executionEndTime, setExecutionEndTime] = useState<string>(
        props.scheduleDTO.executionEndDate ? Utilities.GetTimeFromDateTime(new Date(props.scheduleDTO.executionEndDate)) : Utilities.GetTimeFromDateTime(new Date())
    );
    const [executionNotes, setExecutionNotes] = useState<string>(props.scheduleDTO.executionNotes || '');
    const [executionTechnician, setExecutionTechnician] = useState<string>(props.scheduleDTO.executionTechnicianId || '');
    
    const CreateScheduler = async () => {
        setIsCreatingSchedulingLoading(true);

        const newSchedule: CreateScheduleDTO = {
            assistanceId: props.scheduleDTO.assistanceId || null,
            clientErpId: props.scheduleDTO.clientErpId || null,
            equipmentErpId: props.scheduleDTO.equipmentErpId || null,
            executionStartDate: executionStartDate && executionStartTime ?
                Utilities.CombineDateAndTime(new Date(executionStartDate), executionStartTime) : null,
            executionEndDate: executionEndDate && executionEndTime ?
                Utilities.CombineDateAndTime(new Date(executionEndDate), executionEndTime) : null, executionNotes: executionNotes || null,
            executionTechnicianId: executionTechnician || null,
            observations: props.scheduleDTO.observations || null,

            type: "Execution"
        };

        const response = await schedulerService.Create(newSchedule);
        if (response.success == false) {
            setIsCreatingSchedulingLoading(false);
            Toast.Show("error", response.message);
            return;
        }

        setIsCreatingSchedulingLoading(false);
        Toast.Show("success", response.message);

        props.setScheduleDTO({
            ...props.scheduleDTO,
            assistanceId: response.obj?.id || null,
            assistanceName: `${response.obj?.erpDocType} ${response.obj?.erpSerie} ${response.obj?.erpNumDoc}` || null
        });

        props.onFetchData();
        
        setExecutionStartDate(Utilities.formatDateYYYYMMDD(new Date()));
        setExecutionStartTime(Utilities.GetTimeFromDateTime(new Date()));
        setExecutionEndDate(Utilities.formatDateYYYYMMDD(new Date()));
        setExecutionEndTime(Utilities.GetTimeFromDateTime(new Date()));
        setExecutionNotes('');
        setExecutionTechnician(''); 

    };

    return (
        <div>
            <Row
                style={{
                    margin: "5% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={executionStartDate}
                    label={"Dia Inicial Execução"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setExecutionStartDate(t);

                        const newStartDate = new Date(t + 'T' + executionStartTime);
                        const currentEndDate = new Date(executionEndDate + 'T' + executionEndTime);

                        let newEndDate = executionEndDate;
                        if (currentEndDate < newStartDate) {
                            newEndDate = t;
                            setExecutionEndDate(t);
                        }

                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            executionStartDate: newStartDate,
                            executionEndDate: new Date(newEndDate + 'T' + executionEndTime),
                        });
                    }}
                />
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={executionStartTime}
                    label={"Hora Inicial Execução"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setExecutionStartTime(t);

                        const newStart = new Date(executionStartDate + 'T' + t);
                        const currentEnd = new Date(executionEndDate + 'T' + executionEndTime);

                        let newEndTime = executionEndTime;

                        if (currentEnd < newStart) {
                            const adjustedEnd = new Date(newStart);
                            adjustedEnd.setMinutes(adjustedEnd.getMinutes() + 15);
                            newEndTime = adjustedEnd.toTimeString().substring(0, 5);
                            setExecutionEndTime(newEndTime);
                        }

                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            executionStartDate: newStart,
                            executionEndDate: new Date(executionEndDate + 'T' + newEndTime),
                        });
                    }}
                />
            </Row>
            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={executionEndDate}
                    label={"Dia Final Execução"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setExecutionEndDate(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            executionEndDate: new Date(t + 'T' + executionEndTime)
                        });
                    }}
                />
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={executionEndTime}
                    label={"Hora Final Execução"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setExecutionEndTime(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            executionEndDate: new Date(executionEndDate + 'T' + t)
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={executionNotes}
                    label={"Observações Execução"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setExecutionNotes(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            executionNotes: t
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SelectComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Técnico Execução"}
                    selectedItemValue={executionTechnician}
                    items={Utilities.GetTechnicians}
                    onChange={(t: string) => {
                        setExecutionTechnician(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            executionTechnicianId: t
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "2% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >

                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <ButtonComponent
                        disabled={isCreatingSchedulingLoading}
                        loading={isCreatingSchedulingLoading}
                        text={intl.formatMessage({ id: "Screens.CreateScheduler.Navbar" })}
                        onClick={CreateScheduler}
                        style={{ width: "100%" }}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default CreateSchedulerThirdTab;